import {BulbModule} from "../../core/bulbModule";
import gsap from 'gsap';
import {throttle} from "throttle-debounce";

export default class extends BulbModule {
    constructor(m,opts = {})
    {
        super(m);

        //console.debug('Marquee :: constructor');

        this.eltRepeater  = this.el.querySelector("[data-marquee='repeater']")
        this.cloneTime = 5
        this.xTranslate = 0
        this.scrollSpeed = 0;
        this.oldScrollSpeed = 0;


      // quelques props pour calculer la vitesse de scroll
        this.lastOffset = window.scrollY;
        this.lastDate = new Date().getTime();

      // quelques param par defaut
        this.defaultSpeed = 10;
        this.maxSpeed = 10;
        this.minSpeed = -10;

        this.rafId;
        this.TL;

      // Gestion des events
        this.handleResize = () => {
            this.init()
        }
        this.debouncedHandleResize = throttle(50,false, this.handleResize);
        this.bOn('onEnterViewport', this.play.bind(this))
        this.bOn('onExitViewport', this.pause.bind(this))

    }

    init()
    {

      if(!this.el.classList.contains('linkProject__marquee')){
        this.el.style.marginLeft =- this.eltRepeater.getBoundingClientRect().left +'px';
      }

      this.xTranslateMax = this.eltRepeater.getBoundingClientRect().width ;
        //console.log(this.eltRepeater.getBoundingClientRect())
        let i
        for(i = 0; i < this.cloneTime; i++) {
          let clone = this.eltRepeater.cloneNode(true);
          this.el.appendChild(clone);
        }

        this.TL = gsap.timeline({
            repeat: -1
        });
        this.TL.to(this.el, {x: '-' + this.xTranslateMax, duration: (this.xTranslateMax  / 30), ease: 'none'});

    }

    render()
    {

      // calcul de la vitesse de scroll
        let currentDate = new Date().getTime();
        let scrollTop =  window.scrollY;

        var delayInMs = currentDate - this.lastDate;
        var offset =  scrollTop - this.lastOffset;
        var speedInpxPerMs = offset / delayInMs;


        this.lastDate = currentDate;
        this.lastOffset = scrollTop;

        speedInpxPerMs = Math.min(speedInpxPerMs , this.maxSpeed);
        speedInpxPerMs = Math.max(speedInpxPerMs , this.minSpeed);


        if (isNaN(speedInpxPerMs)) {
            speedInpxPerMs = 0;
        }

        this.scrollSpeed = speedInpxPerMs;


        if (!this.scrollSpeed) {
            this.scrollSpeed = 0;
        }

        if (this.scrollSpeed === 0) {
          // this.xTranslate = '+=' + xIntensity;
            this.TL.timeScale(1);
        } else {
          // this.xTranslate = '-=' + xIntensity;
            this.TL.timeScale(this.scrollSpeed * 5);
        }

        this.rafId = requestAnimationFrame(() => {this.render()});

    }


    destroy()
    {
        super.destroy();
        cancelAnimationFrame(this.rafId);
    }


    play()
    {
        this.render();
        this.TL.play();
    }


    pause()
    {
        cancelAnimationFrame(this.rafId);
        this.TL.pause();
    }
}




// WEBPACK FOOTER //
// ./scripts/utils/effects/marquee.js